import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-start font-weight-bold text-wrap py-4 px-4" }
const _hoisted_2 = { style: {"width":"1100px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_DeclarationForm = _resolveComponent("DeclarationForm")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "pt-2 pl-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "8",
          class: "pr-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "elevation-0 pb-0 fill-height",
              style: {"background":"transparent"}
            }, {
              default: _withCtx(() => [
                (!['EDITION'].includes(_ctx.declaration.status) && _ctx.windowStep === 0)
                  ? (_openBlock(), _createBlock(_component_DocumentMenu, {
                      key: 0,
                      MenuOptions: _ctx.documentMenuOptions,
                      onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                      onDuplicate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.duplicate())),
                      onEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openConfirmationDialog())),
                      onRegenerate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reComputeAccountingLines())),
                      onDisplayAccountingLine: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setStep(1))),
                      onUpdate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateDeclarationStatus())),
                      onActivity: _cache[6] || (_cache[6] = ($event: any) => (_ctx.displayActivityDialog = true))
                    }, null, 8, ["MenuOptions"]))
                  : (!['EDITION'].includes(_ctx.declaration.status) && _ctx.windowStep !== 0)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": "",
                        class: "default_card_wm d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "10" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_back, {
                                class: "ml-1",
                                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({
                                    icon: "$fa-redo-alt",
                                    color: "primary"
                                  }, props, {
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.reComputeAccountingLines()))
                                  }), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _cache[18] || (_cache[18] = _createElementVNode("span", null, "Regénérer l'OD", -1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({
                                    icon: "$oss-edit",
                                    color: "primary",
                                    class: "ml-2"
                                  }, props, {
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openConfirmationDialog()))
                                  }), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _cache[19] || (_cache[19] = _createElementVNode("span", null, "Modifier l'OD", -1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({
                                    icon: "$oss-close",
                                    color: "primary",
                                    class: "ml-2"
                                  }, props, {
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setStep(0)))
                                  }), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _cache[20] || (_cache[20] = _createElementVNode("span", null, "Fermer", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          modelValue: _ctx.windowStep,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.windowStep) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_v_window_item, { key: 0 }, {
                              default: _withCtx(() => [
                                (_ctx.declaration)
                                  ? (_openBlock(), _createBlock(_component_DeclarationForm, {
                                      key: 0,
                                      decId: _ctx.declaration.id,
                                      declaration: _ctx.declaration,
                                      formId: _ctx.declaration.form.id,
                                      "hide-header": !['EDITION'].includes(_ctx.declaration.status)
                                    }, null, 8, ["decId", "declaration", "formId", "hide-header"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })),
                            (_ctx.declaration.document || _ctx.documentId)
                              ? (_openBlock(), _createBlock(_component_v_window_item, {
                                  key: 1,
                                  class: "pt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_accounting_item_static, {
                                      companyId: _ctx.companyId,
                                      documentId: 
                                            _ctx.declaration.document
                                                ? _ctx.declaration.document.id
                                                : _ctx.documentId
                                        ,
                                      mode: "Embedded",
                                      ref: "accountingItemStatic"
                                    }, null, 8, ["companyId", "documentId"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "4",
          class: "my-0 pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","height":"90vh","overflow-y":"auto"},
              class: "default_card_wm elevation-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      "single-line": "",
                      class: "pt-2 pb-0",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          ripple: false,
                          class: "mb-2 rounded-xl",
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      style: {"border-right":"1px #ededed solid"}
                                    }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createElementVNode("b", null, "Nom", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "9",
                                      class: "pl-2 d-flex justify-space-between align-center text-wrap"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.form.name) + " (Millésime " + _toDisplayString(_ctx.form.year) + ") ", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, {
                          ripple: false,
                          class: "mb-2 rounded-xl",
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      style: {"border-right":"1px #ededed solid"}
                                    }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createElementVNode("b", null, "Cerfa", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "9",
                                      class: "pl-2 d-flex justify-space-between text-wrap align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.form.cerfaNumber), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.declaration.status === 'SENT')
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              ripple: false,
                              class: "mb-2 rounded-xl",
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          style: {"border-right":"1px #ededed solid"}
                                        }, {
                                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                                            _createElementVNode("b", null, "Déclaré", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "pl-2 d-flex justify-space-between text-wrap align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.declaration.amountDeclared || 0,
                                                    undefined,
                                                )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.paymentsInfo)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              ripple: false,
                              class: "mb-2 rounded-xl",
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "body-1 pb-4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          style: {"border-right":"1px #ededed solid"}
                                        }, {
                                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                                            _createElementVNode("b", null, "Payé", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "pl-2 d-flex justify-space-between text-wrap align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.paymentsInfo.amountPaid), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentsInfo.paymentsList, (payment) => {
                                      return (_openBlock(), _createBlock(_component_v_row, {
                                        key: payment.iban,
                                        class: "pl-6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(payment.amount) + " € / " + _toDisplayString(payment.iban) + " / " + _toDisplayString(payment.bic), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          ripple: false,
                          class: "mb-2 rounded-xl",
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      style: {"border-right":"1px #ededed solid"}
                                    }, {
                                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                                        _createElementVNode("b", null, "Statut", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "9",
                                      class: "pl-2 d-flex justify-space-between align-center text-wrap"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.translateStatus(_ctx.declaration)), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.displayDate())
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              ripple: false,
                              class: "mb-2 rounded-xl",
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          style: {"border-right":"1px #ededed solid"}
                                        }, {
                                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                                            _createElementVNode("b", null, "Date", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "pl-2 d-flex justify-space-between align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.displayDate()), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.declaration.mtaeId)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              ripple: false,
                              class: "mb-2 rounded-xl",
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          style: {"border-right":"1px #ededed solid"}
                                        }, {
                                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                                            _createElementVNode("b", null, "EDI N°", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "pl-2 d-flex justify-space-between text-wrap align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.declaration.mtaeId), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.declarationErrors.length)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 4,
                              ripple: false,
                              class: "rounded-xl"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                    _createElementVNode("b", null, "Erreurs", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "py-1"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.declarationErrors, (error, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        cols: "11",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_1, _toDisplayString(error.num) + " - " + _toDisplayString(error.detail), 1)
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.miscellaneousOperationDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
      actions: _ctx.actionsMiscellaneousOperation
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.miscellaneousOperationDialog)
            ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                key: 0,
                companyId: _ctx.companyId,
                documentId: _ctx.declaration.document ? _ctx.declaration.document.id : _ctx.documentId,
                actions: _ctx.actionsMiscellaneousOperation
              }, null, 8, ["companyId", "documentId", "actions"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "actions"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.confirmationDialog,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.confirmationDialog) = $event)),
      title: "Confirmation",
      onValid: _cache[14] || (_cache[14] = ($event: any) => (_ctx.confirm()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          style: {"width":"750px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => _cache[29] || (_cache[29] = [
                _createElementVNode("div", { class: "pt-2 px-4 pb-2" }, " En modifiant l'écriture manuellement, vous perdrez le lien entre la déclaration et l'OD de TVA. ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.displayActivityDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.displayActivityDialog,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
          title: "Activité",
          "valid-title": "Fermer",
          width: "60%",
          onValid: _cache[16] || (_cache[16] = ($event: any) => (_ctx.displayActivityDialog = false)),
          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.displayActivityDialog = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UsersActivitiesHistory, {
              declarationId: _ctx.declaration.id
            }, null, 8, ["declarationId"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}